import { PropsWithChildren } from 'react';
import './RevealPanel.css';

type RevealPanelProps = PropsWithChildren<{
    concealed: boolean;
    label: string;
}>;

const RevealPanel = ({
    concealed,
    label,
    children
}: RevealPanelProps) => (
    <div className={`reveal-panel ${concealed ? 'is-concealed' : 'is-revealed'}`}>
        <div className="reveal-panel-content">{children}</div>
        {concealed && (
            <div className="reveal-panel-cover" aria-hidden="true">
                <span>{label}</span>
            </div>
        )}
    </div>
);

export default RevealPanel;
